import { Menu } from "@material-ui/core";

export type { MenuProps as IMenuProps } from "@material-ui/core";

export default Menu;
